module.exports = __webpack_public_path__ + "img/6f_l_okura@2x.4feacc8d.png";